<template>
  <div>
    <v-dialog
      :value="true"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      transition="slide-y-reverse-transition"
      max-width="800"
      scrollable
      persistent
    >
      <ActivityReportForm
        :activityReport="editedActivityReport"
        :errors="activityReportValidationErrors"
        :disabled="savingActivityReport"
        @clear:errors="clearActivityReportValidationErrors"
        @cancel="$router.push({ name: 'activityReports' })"
        @save="onSave"
        @preview="onPreview"
        @select:file="onFileSelect"
      />
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import ActivityReportForm from '../../components/ActivityReportForm';
import store from '../../store';

export default {
  name: 'EditActivityReport',

  components: { ActivityReportForm },

  computed: mapState('activityReports', [
    'editedActivityReport',
    'activityReportValidationErrors',
    'savingActivityReport',
  ]),

  beforeRouteEnter(to, from, next) {
    store
      .dispatch('activityReports/editActivityReport', to.params.id)
      .then(() => {
        next();
      })
      .catch(() => {
        next({ name: 'activityReports' });
      });
  },

  methods: {
    ...mapActions('activityReports', [
      'updateActivityReport',
      'clearActivityReportValidationErrors',
    ]),

    onSave(report) {
      this.updateActivityReport(report).then(() => {
        this.$router.push({ name: 'activityReports' });
      });
    },

    onPreview(report) {
      this.updateActivityReport(report).then(() => {
        window.open(this.$previewBackendUrl('apie?'));
      });
    },

    onFileSelect(files) {
      this.$set(this.editedActivityReport, 'file', files[0]);
      this.$set(this.editedActivityReport, 'original_name', files[0].name);
    },
  },
};
</script>

<style scoped></style>
